import "@/styles/dynamic_page.scss"

import AccordionController from "@/controllers/accordion_controller"
import { loadBackgroundImages } from "@/helpers/image_loader"
import { register } from "@/helpers/stimulus"

const setupStimulus = (): void => {
  register("accordion", AccordionController)
}

setupStimulus()
loadBackgroundImages()
